import axios from 'axios';
import { PMX_DASHBOARD_CONFIG } from './config';
// import store from './store';

// Set config defaults when creating the instance
const instance = axios.create({
	baseURL: PMX_DASHBOARD_CONFIG.API_URL,
});

const currentExecutingRequests = {};
const preventCancellation = ['/graphs', '/graphs/iqvia'];

// Add axios request interceptor
instance.interceptors.request.use(
	function(config) {
		let originalRequest = config;

		const allowedRequests = [...Object.keys(currentExecutingRequests)].some(key =>
			preventCancellation.includes(key)
		);

		// Create cancel token source
		const CancelToken = axios.CancelToken;
		const source = CancelToken.source();

		if (currentExecutingRequests[config.url]) {
			if (!allowedRequests) {
				const source = currentExecutingRequests[config.url];
				delete currentExecutingRequests[config.url];
				source.cancel();
			}
		}

		// Set cancel token on this request
		originalRequest.cancelToken = source.token;
		currentExecutingRequests[config.url] = source;

		// Add to vuex to make cancellation available from anywhere
		// store.commit('cancellation/addCancelTokens', source);
		
        let token = null;

		if (localStorage.getItem('user')) {
			token = JSON.parse(localStorage.getItem('user')).access_token;
		}

		// If a token exists, set authorization header before request is sent
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}

		return originalRequest;
	},
	function(error) {
		return Promise.reject(error);
	}
);

// Add axios response interceptor
instance.interceptors.response.use(
	// Any status code that lie within the range of 2xx cause this function to trigger
	response => {
		if (currentExecutingRequests[response.request.responseURL]) {
			// here you clean the request
			delete currentExecutingRequests[response.request.responseURL];
		}

		return response;
	},
	// Any status codes that falls outside the range of 2xx cause this function to trigger
	error => {
		const { config, response } = error;
		const originalRequest = config;

		if (axios.isCancel(error)) {
			// here you check if this is a cancelled request to drop it silently (without error)
			return new Promise(() => {});
		}

		if (currentExecutingRequests[originalRequest.url]) {
			// here you clean the request
			delete currentExecutingRequests[originalRequest.url];
		}

		// If the response status is 401, it means that the user is not authenticated.
		// If the request is not for the login page, it means that the user is not authenticated and
		// we need to redirect the user to the login page.
		if (401 === response.status && config.url !== '/login') {
			localStorage.clear();
			window.location = '/';
		}

		// here you could check expired token and refresh it if necessary
		return Promise.reject(error);
	}
);

export default instance;
